import * as tslib_1 from "tslib";
import { makeDeleteRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';
var deleteDomainUrl = 'ows/api/v1/PremiumDomain/';
export function deleteDomain() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeDeleteRequest(deleteDomainUrl, undefined, undefined, true)];
                case 1:
                    response = _a.sent();
                    if (isSuccessStatusCode(response.status)) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
//# sourceMappingURL=deleteDomain.js.map